import { Link, useLocation } from "react-router-dom";
import { Rocket, Newspaper, Moon, Cloud, Satellite, Heart } from "lucide-react";

export const MobileNav = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { path: "/", icon: Rocket, label: "Home" },
    { path: "/launches", icon: Rocket, label: "Launches" },
    { path: "/watchlist", icon: Heart, label: "Saved" },
    { path: "/news", icon: Newspaper, label: "News" },
    { path: "/iss", icon: Satellite, label: "ISS" },
    { path: "/moon", icon: Moon, label: "Moon" },
    { path: "/weather", icon: Cloud, label: "Weather" },
  ];

  const isActive = (path) => {
    if (path === "/") return currentPath === "/";
    return currentPath.startsWith(path);
  };

  return (
    <nav className="nav-dock md:left-1/2 md:-translate-x-1/2 md:max-w-lg" data-testid="mobile-nav">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`nav-item ${isActive(item.path) ? "active" : ""}`}
          data-testid={`nav-${item.label.toLowerCase()}`}
        >
          <item.icon className="w-5 h-5" strokeWidth={1.5} />
          <span className="text-[10px] font-heading uppercase tracking-wider hidden sm:block">
            {item.label}
          </span>
        </Link>
      ))}
    </nav>
  );
};
